import http from './http'

const base = '/api/v1'
const newBase = '/api/v2'

export const getTextTo3DConfigController = (param) => http.get(base + '/ai/config', param)

export const getTextTo3Dprompt = (param) => http.get(base + '/ai/prompt', param)

export const getCollectDownload = (param) => http.get(base + '/collect/download', param)

export const getUploadFile = (param, processFn) => http.upload(base + '/model/upload', param, processFn)
export const getNewUploadFile = (param, processFn) => http.upload(newBase + '/model/upload', param, processFn)

export const getUploadImage = (param, processFn) => http.upload(base + '/model/upload/image', param, processFn)
export const getAddModel = (param) => http.post(base + '/model/add', param)
export const getWithdraw = (param) => http.post(base + '/model/withdraw', param)
export const getCreateToken = (param) => http.post(base + '/nft/tokens/login', param)
export const getDownGlb = (param) => http.post(base + '/model/download', param)
export const getDepositConfig = (param) => http.get(base + '/u/alchemy/deposit/config', param)

/**
* 获取腾讯云上传token
* */
export const getTxToken = (param) => http.get(base + '/files/cos', param)

/**
 * 需求清单相关接口
 */
export const createDemand = (param) => http.post(base + '/demand/add', param)

export const getUserModel = (param) => http.get(base + '/user/all', param)

export const getUserToken = (param) => http.get(base + '/unity/user/score', param)

export const withdraw = (param) => http.post(base + '/user/withdraw', param)
export const newWithdraw = (param) => http.postJson(newBase + '/token/withdraw', param)



// WEBPACK FOOTER //
// ./src/service/getData.js